<template>
    <div>
        <h1 class="display-heading">Payout Details</h1>

        <div class="mb-3">
            <table class="table table-bordered">
                <colgroup>
                    <col width="400">
                    <col>
                </colgroup>
                <tbody>
                    <tr>
                        <th>Payment ID</th>
                        <td>
                            {{payout.paymentId}}
                        </td>
                    </tr>
                    <!-- <tr>
                        <th>Payment Received Date</th>
                        <td>
                            {{payout.receivedDate}}
                        </td>
                    </tr> -->
                    <tr>
                        <th>Payment Confirmed Date</th>
                        <td>
                            {{payout.confirmedDate}}
                        </td>
                    </tr>
                    <tr>
                        <th>Status</th>
                        <td>
                            <span
                                class="badge text-nowrap"
                                :class="{
                                    'badge-success': payout.isDisbursed,
                                    'badge-danger': !payout.isDisbursed,
                                }"
                            >
                                {{ payout.status }}
                            </span>
                        </td>
                    </tr>
                    <tr>
                        <th>Disbursement Date</th>
                        <td>
                            {{payout.disbursementDate}}
                        </td>
                    </tr>
                    <tr>
                        <th>Payment Received in IPay88 (RM)</th>
                        <td>
                            {{payout.ipay88}}
                        </td>
                    </tr>
                    <tr>
                        <th>Payment Received in Credit Balance (RM)</th>
                        <td>
                            {{payout.creditBalance}}
                        </td>
                    </tr>
                    <tr>
                        <th>Payment Received in Company Credit (RM)</th>
                        <td>
                            {{payout.companyCredit}}
                        </td>
                    </tr>
                    <tr>
                        <th>Payment Received in Cash (RM)</th>
                        <td>
                            {{payout.cashAmount}}
                        </td>
                    </tr>
                    <tr>
                        <th>Total Charged Amount (RM)</th>
                        <td>
                            {{payout.totalAmount}}
                        </td>
                    </tr>
                    <tr>
                        <th>Partner Disburseable Amount (RM)</th>
                        <td class="text-danger font-weight-bold">
                            {{payout.disburseableAmount}}
                        </td>
                    </tr>
                    <tr>
                        <th>Payment Type</th>
                        <td>
                            {{payout.paymentType}}
                        </td>
                    </tr>
                    <tr v-if="payout.isTelehealthConsultation">
                        <th>Consultation ID</th>
                        <td>
                            {{payout.consultationId}}
                        </td>
                    </tr>
                    <tr v-else-if="payout.isPrescription">
                        <th>Prescription ID</th>
                        <td>
                            {{payout.prescriptionId}}
                        </td>
                    </tr>
                    <tr v-else-if="payout.isClinicConsultation">
                        <th>Consultation ID</th>
                        <td>
                            {{payout.consultationId}}
                        </td>
                    </tr>
                    <tr>
                        <th>Partner Name</th>
                        <td>
                            {{payout.partnerName}}
                        </td>
                    </tr>
                    <tr>
                        <th>Partner Bank Account Payee Name</th>
                        <td>
                            {{payout.partnerBankAccountPayeeName}}
                        </td>
                    </tr>
                    <tr>
                        <th>Partner Bank Name</th>
                        <td>
                            {{payout.partnerBankName}}
                        </td>
                    </tr>
                    <tr>
                        <th>Partner Bank Account Number</th>
                        <td>
                            {{payout.partnerBankAccountNumber}}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <!-- <div class="card mb-3">
            <div class="card-header">Disburse Payout</div>
            <div class="card-body">
                <div v-if="payout.isDisbursed">
                    <p>Payout has been disbursed previously.</p>
                </div>
                <div v-else>
                    <p>Click here to set this payout as disbursed.</p>

                    <button class="btn btn-primary btn-primary-insv" @click="disbursePayout">
                        Disburse Payout
                    </button>
                </div>
            </div>
        </div> -->

        <div>
            <router-link :to="{'name': 'admin-partner-payout'}" class="btn btn-primary btn-primary-insv">
                Back to Payout List
            </router-link>
        </div>

        <popup-modal ref="popupModalConfirmation" :hasCloseButton="false" title="Disburse Payout">
            <template slot="content">
                <p>Are you sure you want to disburse this payout?</p>
                <p>This action cannot be undone!</p>
                <p v-if="disbursement.isDisbursing" :class="{'text-danger': disbursement.isDisburseError}">
                    {{disbursement.disburseMessage}}
                </p>
            </template>
            <template slot="footer">
                <button type="button" class="btn btn-primary btn-primary-insv" @click="confirmDisbursement">Confirm Disbursement</button>
                <button class="btn btn-secondary" @click="dismissConfirm">Cancel</button>
            </template>
        </popup-modal>
    </div>
</template>

<script>
import popupModal from '@/components/popup-modal';
import { convertToUserReadableDateTime } from '@/utilities';
export default {
    'name': 'PayoutDetails',
    'components': {
        popupModal
    },
    'computed': {
        paymentSummaryIdShort () {
            return this.$route.params.paymentId;
        }
    },
    data () {
        return {
            'payout': {
                'isDisbursed': false,
                'paymentId': '',
                'receivedDate': '',
                'confirmedDate': '',
                'status': '',
                'disbursementDate': '',
                'paymentType': '',
                'partnerName': '',
                'partnerBankAccountPayeeName': '',
                'partnerBankName': '',
                'partnerBankAccountNumber': '',
                'totalAmount': ''
            },
            'disbursement': {
                'isDisbursing': false,
                'isDisburseError': false,
                'disburseMessage': ''
            }

        };
    },
    mounted () {
        this.getPayoutDetails();
    },
    'methods': {
        getPayoutDetails () {
            this.axios.get('PaymentList/GetPayoutRecord', {
                'params': {
                    'paymentSummaryId': this.paymentSummaryIdShort
                }
            }).then(({ data }) => {
                let payoutDetails = data.data;

                if (payoutDetails) {
                    let paymentType = 'Others';

                    switch (payoutDetails.pt) {
                    case 1:
                        paymentType = 'Consultation';
                        break;
                    case 2:
                        paymentType = 'Prescription';
                        break;
                    case 4:
                        paymentType = 'Clinic Consultation';
                        break;
                    case 5:
                        paymentType = 'Medicine Delivery';
                        break;
                    }

                    this.payout.isDisbursed = payoutDetails.id;
                    this.payout.paymentId = payoutDetails.psids;
                    this.payout.receivedDate = payoutDetails.rd ? convertToUserReadableDateTime(payoutDetails.rd) : '-';
                    this.payout.confirmedDate = payoutDetails.cd ? convertToUserReadableDateTime(payoutDetails.cd) : '-';
                    this.payout.status = payoutDetails.id ? 'Disbursed' : 'Outstanding';
                    this.payout.isDisbursed = payoutDetails.id;
                    this.payout.disbursementDate = payoutDetails.dd ? convertToUserReadableDateTime(payoutDetails.dd) : '-';
                    this.payout.paymentType = paymentType;
                    this.payout.partnerName = payoutDetails.p ? payoutDetails.p.pn : '-';
                    this.payout.partnerBankAccountPayeeName = payoutDetails.p ? payoutDetails.p.bap : '-';
                    this.payout.partnerBankName = payoutDetails.p ? payoutDetails.p.bn : '-';
                    this.payout.partnerBankAccountNumber = payoutDetails.p ? payoutDetails.p.ba : '-';
                    this.payout.totalAmount = payoutDetails.pa.toFixed(2);
                    this.payout.ipay88 = payoutDetails.iam.toFixed(2);
                    this.payout.creditBalance = payoutDetails.wam.toFixed(2);
                    this.payout.companyCredit = payoutDetails.cam.toFixed(2);
                    this.payout.cashAmount = payoutDetails.ca.toFixed(2);
                    this.payout.disburseableAmount = payoutDetails.da.toFixed(2);

                    this.payout.isTelehealthConsultation = payoutDetails.pt === 1;
                    this.payout.isPrescription = payoutDetails.pt === 2;
                    this.payout.isClinicConsultation = payoutDetails.pt === 4;
                    this.payout.consultationId = payoutDetails.consultationId;
                    this.payout.prescriptionId = payoutDetails.prescriptionId;
                }
            });
        },
        disbursePayout () {
            this.$refs.popupModalConfirmation.show();
        },
        confirmDisbursement () {
            this.disbursement.isDisburseError = false;
            this.disbursement.isDisbursing = true;
            this.disbursement.disburseMessage = 'Updating disbursement status...';
            this.axios.post('PaymentList/DisbursePayout', {
                'psids': this.paymentSummaryIdShort
            }).then(() => {
                location.reload();
            }).catch((error) => {
                this.disbursement.isDisburseError = true;
                if (error.response.data) {
                    this.disbursement.disburseMessage = error.response.data.message;
                } else {
                    this.disbursement.disburseMessage = 'Error saving disbursement status. Please try again.';
                }
            });
        },
        dismissConfirm () {
            this.$refs.popupModalConfirmation.hide();
        }
    }
};

</script>
